// SPARES-PROC-SEP-001 Task 7 — Spare Buying Queue fetcher.
//
// Aggregated view over spare-triggering PRs (auto-reorder + shortage) for
// the spares buyer to work through quote → PO. Read-only; the buyer deep
// links into the existing purchase-indent flow to act on a row.

import { useQuery } from '@tanstack/react-query'
import apiClient from '@/shared/api/client'

export interface SpareBuyingQueueRow {
  id: string
  pr_no: string
  pr_date: string
  status: string
  source: 'AUTO_REORDER' | 'SHORTAGE'
  priority: string
  plant_name: string
  department_name: string
  line_count: number
  estimated_value: number
  age_days: number | null
}

export function useSpareBuyingQueue() {
  return useQuery({
    queryKey: ['stores', 'spare-buying-queue'],
    queryFn: async () => {
      const r = await apiClient.get<SpareBuyingQueueRow[]>('/stores/spare-procurement/buying-queue')
      return r.data
    },
  })
}
